(ns dashboard.views.inference-job.detail.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  ::details
  (fn [db]
    (get-in db [:route.view/inference-job-detail :details])))

(rf/reg-sub
  ::policy-files
  (fn [db]
    (get-in db [:route.view/inference-job-detail :policy-files])))

(rf/reg-sub
  ::questionnaire-details
  (fn [db]
    (get-in db [:route.view/inference-job-detail :questionnaire-details])))

(rf/reg-sub
  ::loading-status
  (fn [db]
    (-> (get-in db [:route.view/inference-job-detail])
        (select-keys [:fetching-details?
                      :fetching-policy-files?
                      :fetching-questionnaire?]))))
